import script from "./TemplateItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateItem.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateItem.vue?vue&type=style&index=0&id=142d6fe1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142d6fe1"]])

export default __exports__